export default __webpack_public_path__ + "static/media/expiryDate1.ef74046a.jpg";